export const ROUTES = {
  CHANNEL_LIST: "/channel/list",
  CHANNEL_DETAILS: "/channel/details",
};
